import React, { useContext } from "react"
import {
  pipe,
  sortArticleByItsItem,
  filterLabelArticle,
  filterArticleWithNumber,
} from "../../providers/article/article.utils"
import { articleContext } from "../../providers/article/article.provider"
import { Container, ArticleWrap } from "./articlePreview.style"
import HomePageTitle from "../homePageTitle/homePageTitle"
import ArticleList from "../articleList/articleList"

const ArticlePreview = ({ className }) => {
  const { articleDatas } = useContext(articleContext)
  const articles = pipe(
    sortArticleByItsItem(`postingTime`),
    filterLabelArticle(0),
    filterArticleWithNumber(8)
  )(articleDatas)

  return (
    <Container className={className}>
      <HomePageTitle>Latest Articles</HomePageTitle>
      <ArticleList articles={articles} />
    </Container>
  )
}

export default ArticlePreview
